<script setup>
// O @click passado pelo pai cai direto na div raiz.
const props = defineProps({
    titulo: {
        type: String,
        required: true
    },
    descricao: {
        type: String,
        default: 'Visualizar'
    },
    // Define o ícone, a partir dos arquivos em public/images/files.
    tipo: {
        type: String,
        default: 'pdf',
        validator: (valor) => ['pdf', 'docx', 'xls', 'jpg', 'boleto'].includes(valor)
    }
});
</script>

<template>
    <div class="border-1 surface-border p-3 pr-5 border-round-2xl cursor-pointer flex flex-row gap-3 hover:surface-100 p-ripple">
        <img :src="`/images/files/${props.tipo}.svg`" width="30">
        <div class="flex flex-column justify-content-center">
            <span class="text-900 text-sm font-medium">{{ props.titulo }}</span>
            <span class="text-400 text-xs">{{ props.descricao }}</span>
        </div>
    </div>
</template>
